// prismjs package from npm ships with all available language grammars
// but they need to be built together to make Prism aware of those
// grammars. We don't want to pre build with a fixed set of
// languages though, but rather dynamically control them via constants.

// The main prismjs package attaches Prism to global object
// upon import, and importing each language component will add
// itself to Prism global object.


const loadPrismLangs = () => {
  if (global && !global.Prism) {
    global.Prism = require('prismjs');
  }

  // NOTE(thx): Can't figure out a way to selectively import
  // languages based on `hljsToPrismLangMap`, as looping and
  // require seems to import and bundle *every file* inside
  // prismjs/components which bloats bundle size..

  // Just manually do it for now.. ಠ_ಠ
  // All "common" languages for highlight.js except for 'apacheconf'.
  require('prismjs/components/prism-bash');
  require('prismjs/components/prism-c');
  require('prismjs/components/prism-csharp');
  require('prismjs/components/prism-cpp');
  require('prismjs/components/prism-css');
  require('prismjs/components/prism-coffeescript');
  require('prismjs/components/prism-diff');
  require('prismjs/components/prism-markup');
  require('prismjs/components/prism-http');
  require('prismjs/components/prism-ini');
  require('prismjs/components/prism-json');
  require('prismjs/components/prism-java');
  require('prismjs/components/prism-javascript');
  require('prismjs/components/prism-makefile');
  require('prismjs/components/prism-markdown');
  require('prismjs/components/prism-nginx');
  require('prismjs/components/prism-objectivec');
  require('prismjs/components/prism-php');
  require('prismjs/components/prism-perl');
  require('prismjs/components/prism-python');
  require('prismjs/components/prism-ruby');
  require('prismjs/components/prism-sql');

  // TODO: Outside these common ones, maybe provide a language dropdown
  // to manually select and then async fetch from cdn with dynamic import()?
  // https://cdnjs.com/libraries/prism
};


export default loadPrismLangs;



// WEBPACK FOOTER //
// ./src/shared/helpers/loadPrismLangs.js